module.exports = __webpack_public_path__ + "static/media/mob-soccer-banner.d84f6cb6.webp";